export default __webpack_public_path__ + "static/media/stethoscope.01dd602b.svg";